<template>
  <PublicPopup
    ref="PopupRef"
    background="transparent"
    padding="0"
    :border-size="0"
    :box-shadow="false"
    :overlay-style="atividadeOverlayStyle"
    @close="emit('close')"
  >
    <template #background>
      <slot name="background"></slot>
    </template>
    <template #content>
      <AtividadeModel ref="ModelRef" :list="list" @close="handlePopupClose" />
      <CheckboxPublic type="atividade" />
    </template>
  </PublicPopup>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { bulletinListApi } from '@/api/messages'

const route = useRoute()
const router = useRouter()

const AtividadePopupChecked = ref(window.localStorage.AtividadePopupChecked || 'null')

const atividadeOverlayStyle = {
  background: 'rgba(0, 0, 0, 0.5)',
}

const ModelRef = ref(null)
const PopupRef = ref(null)
const open = () => {
  if (AtividadePopupChecked.value === 'checked' || !list.value?.length) {
    return false
  }

  if (route.name === 'Home') {
    nextTick(() => {
      PopupRef.value.open()

      nextTick(() => {
        ModelRef.value.change(list.value[0])
      })
    })
    return true
  }
  return false
}
const handlePopupClose = () => {
  PopupRef.value.close()
}

/**
 * id  * 活动ID
 * title  * 标题
 * content  * 富文本
 * img  * 图片
 * msg_type  * 消息类型[1-富文本][2-图片]
 * jump_type  * 跳转类型[1-内链][2-外链]
 * jump_url  * 跳转路由/链接
 */
const list = ref([])
const pageData = reactive({
  page: 1,
  limit: 20,
})
const getList = async () => {
  const res = await bulletinListApi()
  list.value = res.data || []
  await nextTick()
  return open()
}

const emit = defineEmits(['close'])

defineExpose({
  getList,
  open,
})
</script>
